import mod from "-!./priceConfirmation.js?vue&type=script&lang=js&"; export default mod; export * from "-!./priceConfirmation.js?vue&type=script&lang=js&"